import api from '@/utils/api'

export default {
    exportBackOfficeSap(dateRange) {
        return api.get(`back-office/export-sap-checks?startDate=${dateRange[0]}&endDate=${dateRange[1]}`)
    },
    importBilling(formData) {
        return api.uploadFile(`back-office/import-billing`, formData)
    }
}
